module.exports = __webpack_public_path__ + "static/img/00index1_03.b0806db.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/zh/00index1_03.jpg
// module id = WkMD
// module chunks = 0